import axios, { AxiosResponse } from 'axios';

// Define the structure of the Gemini API response
interface GeminiPart {
  text: string;
}

interface GeminiContent {
  parts: GeminiPart[];
}

interface GeminiCandidate {
  content: GeminiContent;
}

interface GeminiResponse {
  candidates: GeminiCandidate[];
}

// Define the request payload structure
interface GeminiRequest {
  contents: Array<{
    parts: Array<{
      text: string;
    }>;
  }>;
}

const generateResponse = async (prompt: string, API_KEY: string): Promise<GeminiResponse> => {
  try {
    const response: AxiosResponse<GeminiResponse> = await axios.post(
      `https://generativelanguage.googleapis.com/v1beta/models/gemini-2.0-flash-exp:generateContent?key=${API_KEY}`,
      {
        contents: [{
          parts: [{
            text: prompt
          }]
        }]
      } as GeminiRequest,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error generating response:', error);
    throw error;
  }
};

export { generateResponse };
